export default __webpack_public_path__ + "e27dde1a6cf206905a8ec96234364072.png";